import { IsNotEmpty, IsUUID } from 'class-validator';

import { NOT_EMPTY_OPTIONS } from '../../constants';

export class DeclineDto {
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  eventId: string;

  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  nodeId: string;
}
